{
  "customFormsFeaturesData": {
    "titles": {
      "checkOut": "Check-out",
      "checkInDeprecated": "Check-in (Deprecated)",
      "checkIn": "Check-in",
      "receivedLoadInspection": "Received Load Inspection",
      "shippedLoadVerification": "Shipped Load Verification",
      "appointmentsPerLoadType": "Appointments per Load Type",
      "assetDetails": "Asset Details",
      "yardManagementSystem": "Yard Management System",
      "smartGateIntegration": "SmartGate integration",
      "gateManagement": "Gate Management",
      "idValidation": "ID Validation",
      "appointmentCompleted": "Appointment Completed"
    },
    "subtitles": {
      "phoneNumberAndCarrierCompanyWillBeCollectedByDefault": "<strong>Phone number</strong> and <strong>carrier company</strong> will be collected by default"
    },
    "descriptions": {
      "captureCheckInDetailsFromDriversForBothPlannedAndUnplannedArrivals": "Capture check-in details from drivers for both planned and unplanned arrivals.",
      "captureCheckOutDataAfterAnAppointmentIsCompleted": "Capture check-out data after an appointment is completed.",
      "collectDriverInfoAsTheySelfCheckInForTheirPlannedAppointmentThisFeatureIsAnOptionalAddOnToOurGateManagementSolution": "Collect driver info as they self check-in for their planned appointment. This feature is an optional add-on to our Gate Management solution.",
      "documentDamageDiscrepanciesOrOtherIssuesRelatedToTheReceivedLoad": "Document damage, discrepancies or other issues related to the received load.",
      "documentLoadIntegrityAndOtherSecurityMeasuresRelatedToTheShippedLoad": "Document load integrity and other security measures related to the shipped load.",
      "captureLoadTypeSpecificDetailsDuringAppointmentScheduling": "Capture load type specific details during appointment scheduling.",
      "storeAndTrackDetailsOfTrailersAndContainersAsTheyArriveAtYourYard": "Store and track details of trailers and containers as they arrive at your yard.",
      "enableTheYmsModuleForThisWarehouseAlsoEnableTheAssetVisitFieldsForTheGateManagementApp": "Enable the YMS module for this warehouse, also enable the asset visit fields for the gate management app.",
      "enableTheSmartGateModuleForThisWarehouse": "Enable the SmartGate module for this warehouse.",
      "enableTheIdValidationForThisWarehouse": "Enable the ID Validation module for this warehouse.",
      "enableTheGateManagementModuleForThisWarehouseWhichIncludesTheCheckIn": "Enable the Gate Management module for this warehouse, which includes the check-in",
      "reviewAndManageAppointmentDataAfterCompletion": "Review and manage appointment data after completion."
    },
    "helpLinks": {
      "learnHowItWorksOrContactUsToRequestATrial": "<a href=\"https://community.loadsmart.com/hc/en-us/articles/19326940613011-Carrier-Self-Check-In\" target=\"_blank\">Learn how it works</a> or contact us to <a href=\"https://lp.opendock.com/gate-management\" target=\"_blank\">request a trial.</a>.",
      "learnHowItWorks": "<a href=\"https://community.loadsmart.com/hc/en-us/articles/19326940613011-Carrier-Self-Check-In\" target=\"_blank\">Learn how it works.</a>"
    },
    "enableDisclaimers": {
      "theDriversWillSeeThisFormWhenTheyAreCheckingThemselvesIn": "The drivers will see this form when they are checking themselves in.",
      "allFieldsOnThisFormWillBeAvailableAndVisibleDuringAppointmentScheduling": "All Fields on this form will be <strong>available and visible</strong> during appointment scheduling."
    },
    "disableDisclaimers": {
      "theDriversWillNotSeeThisFormWhenTheyAreCheckingThemselvesIn": "The drivers will not see this form when they are checking themselves in.",
      "allFieldsOnThisFormWillBeUnavailableDuringAppointmentSchedulingYouCanReEnableThisFormAtAnyTime": "All Fields on this form will be <strong>unavailable</strong> during appointment scheduling.<br />You can re-enable this form at any time."
    },
    "labels": {
      "updateClaimsSupport": "Update Claims Support",
      "selectAClaimsSupportToUpdate": "Select a Claims Support to update",
      "damageType": "Damage Type",
      "damageDescription": "Damage Description",
      "damagePhotos": "Damage Photos",
      "discrepancyType": "Discrepancy Type",
      "discrepancyDescription": "Discrepancy Description",
      "discrepancyPhotos": "Discrepancy Photos",
      "loadSecurityChecked": "Load Security Checked",
      "loadSecurityDescription": "Load Security Description",
      "loadIntegrityPhotos": "Load Integrity Photos",
      "sealIntegrityPhotos": "Seal Integrity Photos"
    }
  }
}
